import React, { useRef, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import getFontPreviewVariant from '../helpers/get-font-preview-variant';
import useFontLoader from '../hooks/use-font-loader';
import {
  isFontOptionVisible,
  subscribeToFontOptionVisibility,
} from '../helpers/font-options-visibility-manager';

const { SkeletonFill } = designSystem;

const FontPreviewOption = ({ children: fontFamily, observer, fontsData }) => {
  const optionRef = useRef(null);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const isOptionIntersecting = isFontOptionVisible(fontFamily);
  const isLoading = useFontLoader(fontFamily, isOptionIntersecting);
  const fontWeight = getFontPreviewVariant(fontsData, fontFamily);

  useEffect(() => {
    const unsubscribe = subscribeToFontOptionVisibility(fontFamily, forceUpdate);

    if (optionRef.current) {
      observer.observe(optionRef.current);
    }

    return () => {
      unsubscribe();
    };
  }, [fontFamily, observer]);

  return (
    <div
      className="ws-font-preview-option"
      style={{ fontFamily, fontWeight }}
      ref={optionRef}
      id={fontFamily}
    >
      {isLoading ? (
        <div className="ws-font-preview-option__skeleton-wrapper">
          <SkeletonFill />
        </div>
      ) : (
        fontFamily
      )}
    </div>
  );
};

FontPreviewOption.propTypes = {
  children: PropTypes.node.isRequired,
  observer: PropTypes.shape({
    observe: PropTypes.func,
  }).isRequired,
  fontsData: PropTypes.arrayOf(
    PropTypes.shape({
      family: PropTypes.string,
      variants: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

export default FontPreviewOption;
